// Package imports:
import React from 'react';
// Component imports:
import ColoredAccordion from '../../ui-elements/ColoredAccordion/ColoredAccordion';
import ExampleReportButton from '../ExampleReportButton/ExampleReportButton';

interface InstructionsProps {
    isIndividual: boolean,
    noAccess?: boolean
}

const Instructions: React.FC<InstructionsProps> = ({
    isIndividual,
    noAccess
}) => {
    const companySteps = () => {
        return <ColoredAccordion
            items={[{
                id: 'step-1',
                title: <p>Hefja könnun</p>,
                content: (
                    <p className='paragraph-small'>
                        Veldu þá viðskiptavini sem hefja skal könnun á. Helstu gögn verða sótt og uppflettingar framkvæmdar á tengilið, prókúruhöfum og raunverulegum eigendum, m.a. í PEP og öðrum válistum.
                    </p>
                )
            }, {
                id: 'step-2',
                title: <p>Skrá tengilið</p>,
                content: (
                    <p className='paragraph-small'>
                        Skráðu tengilið lögaðila ásamt netfangi. Skráður tengiliður þarf að hafa heimild til að koma fram f.h. lögaðila. Þá er valkvætt að senda beiðni á aðra prókúruhafa sem skrá sig inn með rafrænum skilríkjum og sanna á sér deili.
                    </p>
                )
            }, {
                id: 'step-3',
                title: <p>Senda könnun</p>,
                content: (
                    <p className='paragraph-small'>
                        Sendu könnun á skráðan tengilið lögaðila. Tölvupóstur er sendur út í nafni tilkynningarskylds aðila með hlekk á könnun. Tengiliður skráir sig inn með rafrænum skilríkjum og svarar spurningalista. Þessa aðgerð má endurtaka og virkar hún þá sem áminning eða ítrekun.
                    </p>
                )
            }, {
                id: 'step-4',
                title: <p>Áhættumat skráð</p>,
                content: (
                    <p className='paragraph-small'>
                        Skráðu áhættumat handvirkt eða sjálfvirkt með litakóða ásamt athugasemdum þegar öll gögn liggja fyrir, fyrir hvern viðskiptavin eða marga í einu. Hægt er að hlaða upp allt að 10 skjölum við niðurstöðu könnunar.
                    </p>
                )
            }]}
            openId='step-1'
            color='blue'
        />
    }


    const individualSteps = () => {
        return <ColoredAccordion
            items={[{
                id: 'step-1',
                title: <p>Hefja könnun</p>,
                content: (
                    <p className='paragraph-small'>
                        Veldu þá viðskiptavini sem hefja skal könnun á. Helstu gögn verða sótt og uppflettingar framkvæmdar á einstaklingnum, m.a. í PEP og öðrum válistum.
                    </p>
                )
            }, {
                id: 'step-2',
                title: <p>Senda könnun</p>,
                content: (
                    <p className='paragraph-small'>
                        Sendu könnun á einn eða fleiri einstaklinga í einu. Tölvupóstur er sendur út í nafni tilkynningarskylds aðila með hlekk á könnun. Einstaklingar skrá sig inn með rafrænum skilríkjum og svara spurningalista. Þessa aðgerð má endurtaka og virkar hún þá sem áminning eða ítrekun.
                    </p>
                )
            }, {
                id: 'step-3',
                title: <p>Áhættumat skráð</p>,
                content: (
                    <p className='paragraph-small'>
                        Skráðu áhættumat handvirkt eða sjálfvirkt með litakóða ásamt athugasemdum þegar öll gögn liggja fyrir, fyrir hvern viðskiptavin eða marga í einu. Hægt er að hlaða upp allt að 10 skjölum við niðurstöðu könnunar.
                    </p>
                )
            }]}
            openId='step-1'
            color='green'
        />
    }

    return (
        <div className="KCL_instructions">
            <div className="left">
                <div className="text-area">
                    <p className='paragraph'>
                        KYC kerfið („Know your customer“) er ætlað til utanumhalds og framkvæmdar áreiðanleikakannana og stenst þau lög sem tilkynningarskyldir aðilar falla undir um aðgerðir gegn peningaþvætti (AML) og fjármögnun hryðjuverka (CTF). <br />
                    </p>
                    <p className="paragraph">
                        Kerfið gerir notendum kleift að framkvæma áreiðanleikakannanir á einfaldan hátt og öðlast góða yfirsýn á viðskiptavinum, lögaðilum og einstaklingum. Allar aðgerðir eru skráðar og aðgengilegar gagnvart eftirlitsaðilum. <br />
                    </p>

                    {/* Don't show if noAccess */}
                    {!noAccess &&
                        <p className='paragraph'>
                            Áminningar eru sendar sjálfvirkt úr kerfinu þegar hámarks tími er liðinn frá síðustu könnun. Ath. áhættumeiri viðskiptavinir skulu sæta tíðari uppfærslu áreiðanleikakönnunar.
                        </p>
                    }

                    {/* Dont show if noAccess */}
                    {!noAccess &&
                        <ExampleReportButton reportType={isIndividual ? "kyc-individual" : "kyc-company"} size="lg" />
                    }
                </div>
            </div>

            {/* Don't show instructions if noAccess */}
            <div className="right">
                {!noAccess &&
                    <div className="instruction-steps">
                        <h6>Leiðbeiningar fyrir {isIndividual ? 'einstaklinga' : 'lögaðila'}</h6>

                        {!isIndividual && companySteps()}
                        {isIndividual && individualSteps()}
                    </div>
                }
            </div>
        </div>
    );
}

export default Instructions;